// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-customAddToComapny {\n  font-size: 0.75rem;\n  padding-top: 0.125rem;\n  padding-bottom: 0.125rem;\n}\n.b-customAddToComapny span {\n  line-height: 1rem;\n}", ""]);
// Exports
module.exports = exports;
